import styled from 'styled-components';

export const TduContactLaterSection = styled.div`
    position: relative;
    margin-top: 88px;

    &::before {
        content: '';
        position: absolute;
        top: -44px;
        left: 50%;
        transform: translateX(-50%);
        width: min(300px, 60%);
        height: 1px;
        background-color: #ddd;
    }

    > p {
        font-size: 14px;
        line-height: 1.45;
        color: #666;
        margin-bottom: 8px;
    }
`